
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.723 21a4.808 4.808 0 01-3.343-1.318 4.383 4.383 0 010-6.383l9.777-9.336c1.399-1.335 3.573-1.276 5.056.14 1.483 1.417 1.547 3.493.148 4.829l-9.185 8.77a2.29 2.29 0 01-3.13 0 2.05 2.05 0 010-2.989l6.222-5.94c.21-.201.55-.201.76 0 .21.2.21.524 0 .725l-6.222 5.94a1.055 1.055 0 000 1.539 1.18 1.18 0 001.61 0l9.186-8.77c.965-.923.902-2.375-.149-3.378-1.05-1.003-2.57-1.063-3.536-.14L5.14 14.023a3.385 3.385 0 000 4.933 3.716 3.716 0 002.583 1.017c.978 0 1.896-.361 2.583-1.017l9.777-9.336c.21-.2.55-.2.76 0 .21.2.21.525 0 .725l-9.778 9.336A4.81 4.81 0 017.723 21z","fill-rule":"nonzero"}})])
          )
        }
      }
    